import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
/** @jsx jsx */

import React from 'react';
import { jsx } from '@emotion/core';
import Button from '@atlaskit/button/custom-theme-button';
import { internalFooterStyles } from '../styles/content';
export default function ModalFooter(props) {
  var actions = props.actions,
      appearance = props.appearance,
      component = props.component,
      onClose = props.onClose,
      testId = props.testId;
  var warning = 'You can provide `component` OR `actions`, not both.';

  if (!component && !actions) {
    return null;
  }

  if (component && actions) {
    console.warn(warning); // eslint-disable-line no-console

    return null;
  }

  if (component) {
    return /*#__PURE__*/React.createElement(component, {
      appearance: appearance,
      onClose: onClose
    });
  }

  return jsx("div", {
    css: internalFooterStyles,
    "data-testid": testId && "".concat(testId, "--footer")
  }, actions && actions.map(function (_ref, index) {
    var text = _ref.text,
        rest = _objectWithoutProperties(_ref, ["text"]);

    return jsx(Button, _extends({
      key: index,
      appearance: index !== 0 ? 'subtle' : appearance || 'primary',
      "data-ds--modal-dialog--action": true,
      testId: testId && "".concat(testId, "--action-").concat(index)
    }, rest), text);
  }));
}